

export const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds
        }`;
};




const formatTimeRecord = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

};


export   const formatTimeInHHMMSS = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    
    return `${hours < 10 ?   hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes}:${
        seconds < 10 ? "0" + seconds : seconds}`;
};




// Function to convert "HH:MM:SS" to seconds
export const timeStringToSeconds = (timeString) => {
    const parts = timeString?.split(":").map(Number); // Split by ":" and convert to numbers
    const [hours = 0, minutes = 0, seconds = 0] = parts;

    return (hours * 3600) + (minutes * 60) + seconds;
};

// Function to format seconds into HH:MM:SS or MM:SS
export const formatTimeWithOptionalHours = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.floor(timeInSeconds % 60);

    // If hours are zero, only display minutes and seconds
    if (hours === 0) {
        return `${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
    }

    // Otherwise, display hours, minutes, and seconds
    return `${hours < 10 ? "0" + hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes
    }:${seconds < 10 ? "0" + seconds : seconds}`;
};

// timeDuration is stored as HH:MM:SS by the app and as plain seconds by some uploads.
export const durationToSeconds = (timeDuration) => {
    if (timeDuration === null || timeDuration === undefined || timeDuration === "") {
        return 0;
    }

    const value = `${timeDuration}`;

    return value.includes(":") ? timeStringToSeconds(value) : Number(value) || 0;
};
